import "../sass/child-styles.scss"

import ChildThemeAnimations from "./modules/ChildThemeAnimations";
import DynamicSiteLogo from "./modules/./DynamicSiteLogo";

const childThemeAnimations = new ChildThemeAnimations();
const dynamicSiteLogo = new DynamicSiteLogo();